export default "__VITE_ASSET__c84428e3__"